import { history } from 'common/services/history';
import addTicketUseCase from 'tickets/services/addTicketUseCase';
import updateTicketDetailUseCase from 'tickets/services/detail/updateTicketDetailUseCase';
import { updateReac2 } from 'actions/reacondicionadosActions';

const addTicketFromReacUseCase = async (items) => {
    const list = Array.isArray(items) ? items : [items];

    const concept = list.map(item =>
        `${item.modelo || 'Dispositivo'} ${item.capacidad || ''} ${item.color || ''}`.trim()
    ).join(', ');

    const ticket = {
        concept,
        taskReference: list.map(i => i.reference).filter(Boolean).join(', '),
    };

    const data = list.map(item => ({
        reference: item.reference || '',
        description: `${item.modelo || 'Dispositivo'} ${item.capacidad || ''} ${item.color || ''}`.trim(),
        unitPrice: item.precio || 0,
        units: 1,
        iva: true,
    }));

    const idTicket = await addTicketUseCase(ticket);
    await updateTicketDetailUseCase({ ...ticket, id: idTicket }, null, { data });

    const fechaVenta = new Date().getTime();
    await Promise.all(list.map(item => updateReac2({ ...item, estado: 'vendido', vendido: true, fechaVenta: item.fechaVenta || fechaVenta })));

    history.push(`/tickets?id=${idTicket}`);
};

export default addTicketFromReacUseCase;
